import { rpApi } from "@/http";

type ApiGetResult = ReturnType<typeof rpApi.get>;

export default {
  getSimpleInfo(shelfId: string): ApiGetResult {
    return rpApi.get("/shelf-web/v1/shelf/simpleInfo", { shelfId });
  },
  getDetail(shelfId: string): ApiGetResult {
    return rpApi.get("/shelf-web/v1/shelf/detail", { shelfId });
  },
};
